import React from 'react';

import ApprovalCardDetails from '@/modules/settings/approvals/components/shared/ApprovalDetails/ApprovalCardDetails';
import ApproverUsersList from '@/modules/settings/approvals/components/shared/ApprovalDetails/ApproverUsersList';
import { IApprovals } from '@/modules/settings/approvals/types';
import { IIconWithTitleDescriptionProps } from '@/shared/components/atoms/IconWithTItleDescription/IconWithTitleDescription';
interface IProps {
  cards: IIconWithTitleDescriptionProps[];
  approvers: IApprovals.IApproverItem[];
  entityId: number;
  approvalPathId: number;
}

const ApprovalDetails = ({
  cards,
  approvers,
  entityId,
  approvalPathId,
}: IProps) => {
  return (
    <>
      <div className='px-24'>
        <ApprovalCardDetails data={cards} />
      </div>
      <div className='mt-24 '>
        <ApproverUsersList
          approvers={approvers}
          entityId={entityId}
          approvalPathId={approvalPathId}
        />
      </div>
    </>
  );
};
export default ApprovalDetails;
